var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Flavor Text')))]), _c('v-list-item', [_c('Voice', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "name": _vm.name,
      "cue": "voice_flavor_0"
    }
  }), _c('v-list-item-content', {
    staticClass: "mr-auto ml-0",
    staticStyle: {
      "max-width": "384px"
    }
  }, [_c('div', {
    style: {
      'line-height': 1.5,
      'font-size': _vm.$vuetify.breakpoint.xsOnly ? '70%' : null
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text(_vm.flavor.m_FlavorText))
    }
  })])], 1), _vm.flavors.length ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "float-right pr-4"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.show = !_vm.show;
      }
    }
  }, [_vm.show ? _c('v-icon', [_vm._v("mdi-chevron-up")]) : _c('v-icon', [_vm._v("mdi-chevron-down")])], 1)], 1), _c('p', {
    staticClass: "title px-4 primary--text",
    on: {
      "click": function click($event) {
        _vm.show = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Creamate Commu Text')))]), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }]
  }, _vm._l(_vm.flavors, function (flavor, i) {
    return _c('v-list-item', {
      key: "character-flavor-".concat(i)
    }, [_c('v-list-item-avatar', {
      staticClass: "mx-auto mr-0",
      attrs: {
        "size": _vm.$size(32),
        "color": "primary"
      }
    }, [_c('span', {
      staticClass: "white--text"
    }, [_vm._v(_vm._s(flavor.m_ConditionId % 10))])]), _c('v-list-item-avatar', {
      staticClass: "mx-2 mr-md-4",
      attrs: {
        "size": _vm.$size(32)
      }
    }, [_c('span', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(_vm.$t("Flavor Condition Types.".concat(flavor.m_ConditionType))))])]), _c('v-list-item-content', {
      staticClass: "mr-auto ml-0",
      staticStyle: {
        "max-width": "384px"
      }
    }, [_c('div', {
      style: {
        'line-height': 1.5,
        'font-size': _vm.$vuetify.breakpoint.xsOnly ? '70%' : null
      },
      domProps: {
        "innerHTML": _vm._s(_vm.text(flavor.m_Body))
      }
    })])], 1);
  }), 1)])] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }